import { render } from "./Npcs.vue?vue&type=template&id=d149e966"
import script from "./Npcs.vue?vue&type=script&lang=js"
export * from "./Npcs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__